const Config = {
  LoginPath: process.env.VUE_APP_LOGIN_PATH,
  LogoutPath: process.env.VUE_APP_LOGOUT_PATH,
  APIPath: process.env.VUE_APP_API_PATH,
  RZAppKey: process.env.VUE_APP_RZ_APP_KEY,
  ThemeName: process.env.VUE_APP_RZ_THEME_NAME || null,
  title: 'Roanuz Accounts'
}

export default Config
